import lodashGet from 'lodash/get';
import { setProtonsCount } from './setProtonsCount';
/**
 * Sets proton counts from edited HSQC signals.
 *
 * @param {Values} correlations
 * @param {Experiment2DSignals} signals2D
 * @param {Tolerance} tolerance
 * @param {string} heavyAtomType
 */
export function setProtonsCountFromEditedHSQC(correlations, signals2D, tolerance, heavyAtomType) {
    const correlationsAtomTypeHSQC = correlations.filter((correlation) => correlation.pseudo === false && correlation.atomType === heavyAtomType);
    const signalsEditedHSQC = lodashGet(signals2D, 'hsqc', [])
        .filter((signal2D) => signal2D.atomType[1] === heavyAtomType && signal2D.signal.sign !== 0)
        .map((signal2D) => {
        return { delta: signal2D.signal.y.delta, sign: signal2D.signal.sign };
    });
    setProtonsCount(correlationsAtomTypeHSQC, [], signalsEditedHSQC, tolerance[heavyAtomType]);
    return correlations;
}
//# sourceMappingURL=setProtonsCountFromEditedHSQC.js.map